import { useRouter } from "next/router";
import React, { FC } from "react";
import { Collapse } from "../components";
import { WithRootLayout } from "../hoc/withRootLayout";
import { translate } from "../utils";

const Privacy: FC = (): JSX.Element => {
  const { locale } = useRouter();
  const content = [
    {
      title: translate(locale, "privacy_content_title_1"),
      mainContent: (
        <>
          <p>{translate(locale, "privacy_main_content_1_p1")}</p>
          <p>{translate(locale, "privacy_main_content_1_p2")}</p>
        </>
      ),
      additionalContent: (
        <>
          <h4>{`a) ${translate(locale, "privacy_additional_1_title")}`}</h4>
          <p>{translate(locale, "privacy_additional_1_p1")}</p>
          <h4>{`b) ${translate(locale, "privacy_content_title_2")} `}</h4>
          <p>{translate(locale, "privacy_main_content_2_p1")}</p>
          <h4>{`c) ${translate(locale, "privacy_content_title_3")}`}</h4>
          <p>{translate(locale, "privacy_main_content_3_p1")}</p>
          <h4>{`d) ${translate(locale, "privacy_content_title_4")}`}</h4>
          <p>{translate(locale, "privacy_main_content_4_p1")}</p>
          <h4>{`e) ${translate(locale, "privacy_content_title_5")}`}</h4>
          <p>{translate(locale, "privacy_main_content_5_p1")}</p>
          <h4>{`f) ${translate(locale, "privacy_content_title_6")}`}</h4>
          <p>{translate(locale, "privacy_main_content_6_p1")}</p>
          <h4>{`g) ${translate(locale, "privacy_content_title_7")}`}</h4>
          <p>{translate(locale, "privacy_main_content_7_p1")}</p>
          <h4>{`h) ${translate(locale, "privacy_content_title_8")}`}</h4>
          <p>{translate(locale, "privacy_main_content_8_p1")}</p>
          <h4>{`i) ${translate(locale, "privacy_content_title_9")}`}</h4>
          <p>{translate(locale, "privacy_main_content_9_p1")}</p>
          <h4>{`j) ${translate(locale, "privacy_content_title_10")}`}</h4>
          <p>{translate(locale, "privacy_main_content_10_p1")}</p>
          <h4>{`k) ${translate(locale, "privacy_content_title_11")}`}</h4>
          <p>{translate(locale, "privacy_main_content_11_p1")}</p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_12"),
      mainContent: (
        <>
          <p>{translate(locale, "privacy_main_content_12_p1")}</p>
          <p>
             RION Energie GmbH
            <br /> Heimstrasse 12
            <br /> 8953 Dietikon (ZH) Dietikon
            <br /> Suisse
          </p>
          <p>
            {`${translate(locale, "contacts_phone")}: +41 (0)78 934 96 46`}
            <br />
            {`${translate(locale, "contacts_email")}: info@rion-energie.ch`}
            <br />
            {`${translate(locale, "website")}: www.rion-energie.ch`}
          </p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_13"),
      mainContent: (
        <>
          <p>{translate(locale, "privacy_main_content_13_p1")}</p>
          <p>{translate(locale, "privacy_main_content_13_p2")}</p>
          <p>{translate(locale, "privacy_main_content_13_p3")}</p>
          <p>{translate(locale, "privacy_main_content_13_p4")}</p>
          <p>{translate(locale, "privacy_main_content_13_p5")}</p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_14"),
      mainContent: (
        <>
          <p>{translate(locale, "privacy_main_content_14_p1")}</p>
          <p>{translate(locale, "privacy_main_content_14_p2")}</p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_15"),
      mainContent: <p>{translate(locale, "privacy_main_content_15_p1")}</p>,
    },
    {
      title: translate(locale, "privacy_content_title_16"),
      mainContent: (
        <>
          <p>{translate(locale, "privacy_main_content_16_p1")}</p>
          <p>{translate(locale, "privacy_main_content_16_p2")}</p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_17"),
      additionalContent: (
        <>
          <h4>
            a)&nbsp;&nbsp;&nbsp;
            {translate(locale, "privacy_main_content_17_p1")}
          </h4>
          <p>{translate(locale, "privacy_main_content_17_p2")}</p>
          <h4>
            b)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_18")}
          </h4>
          <span>{translate(locale, "privacy_main_content_18_p1")}</span>
          <ul>
            <li>{translate(locale, "privacy_main_content_18_li1")}</li>
            <li>{translate(locale, "privacy_main_content_18_li2")}</li>
            <li>{translate(locale, "privacy_main_content_18_li3")}</li>
            <li>{translate(locale, "privacy_main_content_18_li4")}</li>
            <li>{translate(locale, "privacy_main_content_18_li5")}</li>
            <li>{translate(locale, "privacy_main_content_18_li6")}</li>
            <li>{translate(locale, "privacy_main_content_18_li7")}</li>
            <li>{translate(locale, "privacy_main_content_18_li8")}</li>
          </ul>
          <p>{translate(locale, "privacy_main_content_18_p2")}</p>
          <p>{translate(locale, "privacy_main_content_18_p3")}</p>
          <h4>
            c)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_19")}
          </h4>
          <p>{translate(locale, "privacy_main_content_19_p1")}</p>
          <p>{translate(locale, "privacy_main_content_19_p2")}</p>
          <h4>
            d)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_20")}
          </h4>
          <span>{translate(locale, "privacy_main_content_20_p1")}</span>
          <ul>
            <li>{translate(locale, "privacy_main_content_20_p2")}</li>
            <li>{translate(locale, "privacy_main_content_20_p3")}</li>
            <li>{translate(locale, "privacy_main_content_20_p4")}</li>
            <li>{translate(locale, "privacy_main_content_20_p5")}</li>
            <li>{translate(locale, "privacy_main_content_20_p6")}</li>
            <li>{translate(locale, "privacy_main_content_20_p7")}</li>
          </ul>
          <p>{translate(locale, "privacy_main_content_20_p8")}</p>
          <p>{translate(locale, "privacy_main_content_20_p9")}</p>
          <h4>
            e)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_21")}
          </h4>
          <span>{translate(locale, "privacy_main_content_21_p1")}</span>
          <ul>
            <li>{translate(locale, "privacy_main_content_21_li1")}</li>
            <li>{translate(locale, "privacy_main_content_21_li2")}</li>
            <li>{translate(locale, "privacy_main_content_21_li3")}</li>
            <li>{translate(locale, "privacy_main_content_21_li4")}</li>
          </ul>
          <h4>
            f)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_22")}
          </h4>
          <p>{translate(locale, "privacy_main_content_22_p1")}</p>
          <p>{translate(locale, "privacy_main_content_22_p2")}</p>
          <p>{translate(locale, "privacy_main_content_22_p3")}</p>
          <h4>
            g)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_23")}
          </h4>
          <p>{translate(locale, "privacy_main_content_23_p1")}</p>
          <p>{translate(locale, "privacy_main_content_23_p2")}</p>
          <p>{translate(locale, "privacy_main_content_23_p3")}</p>
          <p>{translate(locale, "privacy_main_content_23_p4")}</p>
          <p>{translate(locale, "privacy_main_content_23_p5")}</p>
          <h4>
            h)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_24")}
          </h4>
          <p>{translate(locale, "privacy_main_content_24_p1")}</p>
          <p>{translate(locale, "privacy_main_content_24_p2")}</p>
          <p>{translate(locale, "privacy_main_content_24_p3")}</p>
          <h4>
            i)&nbsp;&nbsp;&nbsp;{translate(locale, "privacy_content_title_25")}
          </h4>
          <p>{translate(locale, "privacy_main_content_25_p1")}</p>
          <p>{translate(locale, "privacy_main_content_25_p2")}</p>
        </>
      ),
    },
    {
      title: translate(locale, "privacy_content_title_26"),
      mainContent: <p>{translate(locale, "privacy_main_content_26_p1")}</p>,
    },
    {
      title: translate(locale, "privacy_content_title_27"),
      mainContent: <p>{translate(locale, "privacy_main_content_27_p1")}</p>,
    },
    {
      title: translate(locale, "privacy_content_title_28"),
      mainContent: <p>{translate(locale, "privacy_main_content_28_p1")}</p>,
    },
    {
      title: translate(locale, "privacy_content_title_29"),
      mainContent: <p>{translate(locale, "privacy_main_content_29_p1")}</p>,
    },
    {
      title: translate(locale, "privacy_content_title_30"),
      mainContent: <p>{translate(locale, "privacy_main_content_30_p1")}</p>,
    },
  ];

  return (
    <div className="privacy">
      <h1>{translate(locale, "data_protection_title")}</h1>
      <p>{translate(locale, "data_protection_p1")}</p>
      <p>{translate(locale, "data_protection_p2")}</p>
      <p>{translate(locale, "data_protection_p3")}</p>
      <div className="collapse-container">
        {content.map((item, index) => (
          <Collapse
            key={item.title}
            title={item.title}
            mainContent={item.mainContent}
            isOpenByDefault={index === 0}
            additionalContent={item.additionalContent}
          />
        ))}
      </div>
      <p>{translate(locale, "data_protection_p4")}</p>
    </div>
  );
};

export default WithRootLayout(Privacy);
